import { useIsB2BSelected } from "./useIsB2BSelected";
import { useCarSelector } from "@redux/reducers/appConfig";
import { useCarConfigurationSelector } from "@redux/reducers/deal";
import {
  BUSINESS_MODELS_TARGET_KEYS,
  CUSTOMIZE_TYPES,
} from "@shared/constants";
import { useIsCashJourneySelected } from "./useIsCashJourneySelected";

export const useAvailableServices = () => {
  const currentCar = useCarConfigurationSelector();
  const { lcdvCode } = currentCar.preconfiguration;
  const { services: allServices } = useCarSelector();
  const isB2BSelected = useIsB2BSelected();
  const isCashJourneySelected = useIsCashJourneySelected();

  const targetKey = isB2BSelected
    ? BUSINESS_MODELS_TARGET_KEYS.B2B
    : BUSINESS_MODELS_TARGET_KEYS.B2C;

  const services = [];

  if (isCashJourneySelected) {
    allServices
      .filter(
        service => service[targetKey] === true && service.lcdvCode === lcdvCode
      )
      .forEach(service => {
        services.push({
          type: CUSTOMIZE_TYPES.SERVICE,
          item: service,
          selected: currentCar.service.some(serv => serv.id === service.id),
        });
      });
  }

  return services;
};
